module.exports = __webpack_public_path__ + "img/menu23.734ee1e3.png";